import * as React from "react";
import { formatValueOnPlanAndTotalType } from "../pinned-row-helpers";
import { IPlanMetricDoorRendererProps } from "./plan-metric-door-column";

export const PlanRow: React.FunctionComponent<IPlanMetricDoorRendererProps> = ({
    totalType,
    style,
    currency,
    plan,
    planRowType,
}) => {
    const value = formatValueOnPlanAndTotalType({ value: plan, totalType, currency, planRowType });

    return (
        <div style={style} className="planCell">
            <div className="planValue">{value}</div>
        </div>
    );
};
